/* eslint-disable @typescript-eslint/no-unsafe-return */
import palette from '@theme/assets/palette';
import { GroupBase, StylesConfig } from 'react-select';
import { SelectItem } from 'types/formElement';

export const select = (
    isCompact: boolean,
    isInvalid: boolean,
): StylesConfig<SelectItem, false, GroupBase<SelectItem>> => {
    return {
        container: (baseStyle: any) => ({
            ...baseStyle,
            outlineColor: 'red',
            outlineWidth: isInvalid ? '1px' : '0',
            outlineStyle: 'solid',
            borderRadius: 4,
        }),
        control: (baseStyle: any, { isFocused }) => ({
            ...baseStyle,
            borderRadius: 4,
            borderColor: isFocused ? palette.black : palette.ui01,
            borderWidth: isCompact ? 0 : 1,
            boxShadow: 'none',
            ':hover': {
                borderColor: palette.black,
            },
        }),
        valueContainer: (baseStyle: any) => ({
            ...baseStyle,
            paddingTop: 3,
            paddingBottom: 3,
        }),
        indicatorSeparator: (baseStyle: any) => ({
            ...baseStyle,
            width: 0,
            borderWidth: 0,
        }),
        placeholder: (baseStyle: any) => ({
            ...baseStyle,
            color: palette.ui03,
        }),
        menu: (baseStyle: any) => ({
            ...baseStyle,
            zIndex: 99,
            color: 'rgba(0, 0, 0, 0.87)',
        }),
    };
};
